export const sharedCapitalFilterState = () => ({
  searchKey: '',
  status: 'all',
  page: 1,
  perPage: 10,
  orderBy: 'createdAt',
  order: 'desc'
});
